/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://ze6854em62.execute-api.eu-west-1.amazonaws.com/trula",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://hipbh7s5ancjrjt2vuzs322wom.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:6df23b48-d08a-4573-ab12-912c666c8ff9",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_RDjP9N8Jx",
    "aws_user_pools_web_client_id": "2k2vgl116rpfghjbsmembeag64",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "esfilesdevelop222058-trula",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
